import { useCallback, useEffect } from "react";
import { useApi } from "./useApi";
import { useStateValue } from "../context/StateValueContext";
import { PPAccount } from "../types/paymentProcessor";
import * as Sentry from "@sentry/react";

export function usePpAccounts() {
  const { get } = useApi();
  const [{ ppAccounts }, dispatch] = useStateValue();

  const fetchPpAccounts = useCallback(async () => {
    try {
      const response = await get<{ accounts: PPAccount[] }>(`/api/pp-accounts`);
      dispatch({ type: "SET_PP_ACCOUNTS", ppAccounts: response.accounts });
    } catch (err) {
      console.error("Failed to fetch PP accounts:", err);
      Sentry.captureException(err);
    }
  }, [get, dispatch]);

  useEffect(() => {
    if (ppAccounts.length === 0) {
      fetchPpAccounts();
    }
  }, [ppAccounts.length, fetchPpAccounts]);

  return { ppAccounts };
}
